import styled from "styled-components";
import { colors } from "../../theme/color";

export const SearchBarWrapper = styled.div`
  position: relative;
  display: flex;
  width: 27rem;
  height: 40px;
  box-sizing: border-box;
  padding: 12px 15px 12px 5px;
  align-items: center;
  border-radius: 10px;
  background: var(--General-White, #fff);
  transition: all 0.3s ease;
  @media only screen and (max-width: 766px) {
  }
`;

export const SearchInput = styled.input`
  height: 100%;
  width: 100%;
  text-indent: 50px;
  position: absolute;
  background-color: transparent;
  outline: none;
  font-size: 12px;
  border: 1px solid #e8eaed;
  border-radius: 10px;
  box-sizing: border-box;
  &::placeholder {
    font-family: GT Walsheim Pro;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0.02em;
    text-align: left;
    color: #868686;
  }

  &:focus {
    border-color: ${colors.ButtonBackgroundColors.primaryMediumHoverButton};
  }
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const IconButton = styled.div`
  flex-shrink: 0;
  z-index: 1;
  cursor: pointer;
  padding-left: 20px;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;

  &:hover {
    color: ${colors.ButtonBackgroundColors.primaryMediumHoverButton};
    &::after {
      opacity: 1;
      transform: scale(1);
    }
  }
`;
